import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useVehicle } from '../context/VehicleContext';
import API_URL from "../api/baseURL";


const OemAssistant = ({ token }) => {
  const { selectedVehicle, setSelectedVehicle } = useVehicle();
  const [vehicles, setVehicles] = useState([]);
  const [query, setQuery] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Fetch user's vehicles
    axios.get(`${API_URL}/vehicles/mine`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => {
        const list = res.data;
        setVehicles(list);

        // Auto-select logic
        if (list.length === 1) {
          setSelectedVehicle(list[0]);
        }
      })
      .catch(err => console.error('Vehicle fetch failed:', err));
  }, [token, setSelectedVehicle]);

  const handleSearch = async () => {
    if (!query || !selectedVehicle?.vin) return;
    setLoading(true);
    try {
      const res = await axios.post(`${API_URL}/ai/oem-search`, {
        vin: selectedVehicle.vin,
        query
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setResult(res.data);
    } catch (err) {
      console.error("AI search failed", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto p-6">
      <h2 className="text-xl font-bold mb-4">🧠 OEM Part Finder</h2>

      {vehicles.length === 0 ? (
        <p className="text-red-600 mb-4">You don’t have any vehicles registered yet.</p>
      ) : vehicles.length > 1 && (
        <div className="mb-4">
          <label className="block mb-1 text-sm font-semibold">Select Vehicle:</label>
          <select
            className="w-full border p-2 rounded"
            value={selectedVehicle?.vin || ''}
            onChange={e => {
              const match = vehicles.find(v => v.vin === e.target.value);
              setSelectedVehicle(match || null);
            }}
          >
            <option value="">-- Select a vehicle --</option>
            {vehicles.map(v => (
              <option key={v._id} value={v.vin}>
                {v.make} {v.model} ({v.year}) — {v.vin}
              </option>
            ))}
          </select>
        </div>
      )}

      {selectedVehicle && (
        <p className="mb-4 text-sm text-[#C9C3B6]">
          <strong>VIN:</strong> {selectedVehicle.vin} ({selectedVehicle.make} {selectedVehicle.model}, {selectedVehicle.year})
        </p>
      )}

      <input
        placeholder="e.g. front brake pads"
        value={query}
        onChange={e => setQuery(e.target.value)}
        className="w-full border p-2 rounded mb-4"
      />

      <button
        onClick={handleSearch}
        disabled={loading || !selectedVehicle?.vin || !query}
        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
      >
        {loading ? 'Searching...' : 'Find OEM Part'}
      </button>

      {result && (
        <div className="mt-6 p-4 bg-[#1B1815] rounded">
          <p><strong>VIN:</strong> {result.vin}</p>
          <p><strong>OEM:</strong> {result.oem}</p>
          <p><strong>Part Name:</strong> {result.partName}</p>
          <p><strong>Note:</strong> {result.note}</p>
          <p><strong>Source:</strong> {result.source === 'catalog' ? 'Catalog Match' : 'AI Response'}</p>

          <h4 className="mt-4 font-semibold">Aftermarket Equivalents:</h4>
          <ul className="list-disc ml-6">
            {result.equivalents?.map((e, i) => (
              <li key={i}>{e.brand}: {e.ref}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default OemAssistant;
